import { useQuery } from "react-query";
import { getPaymentMethods } from "../services/finance/paymentMethods";
import { PagedRequestType } from "../types/PagedResults";
import { Key_paymentMethods } from "../utils/constants";

export const useGetPaymentMethodsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_paymentMethods, JSON.stringify(data)],
    () => getPaymentMethods(data), 
    options?{...options}:{}
  );